import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { type RimmEntityType, type RimmSubEntityType } from '../data/rimmEntityEnums';
import { type IRimmDataItem } from '../data/rimmEntityTypes';

type RimmEntityState = {
  data: IRimmDataItem[];
  totalCount: number;
};

export type RimmState = Record<RimmEntityType, RimmEntityState> &
  Record<RimmSubEntityType, Record<string, Omit<RimmEntityState, 'isLoading'>>>;

const initialState: RimmState = {
  commodity: {
    data: [],
    totalCount: 0,
  },
  packageType: {
    data: [],
    totalCount: 0,
  },
  packageClass: {
    data: [],
    totalCount: 0,
  },
  country: {
    data: [],
    totalCount: 0,
  },
  company: {
    data: [],
    totalCount: 0,
  },
  termsOfDelivery: {
    data: [],
    totalCount: 0,
  },
  exchangeRate: {
    data: [],
    totalCount: 0,
  },
  port: {
    data: [],
    totalCount: 0,
  },
  attachedDocument: {
    data: [],
    totalCount: 0,
  },
  ministry: {
    data: [],
    totalCount: 0,
  },
  ministryDepartments: {},
  unitOfMeasurement: {
    data: [],
    totalCount: 0,
  },
  declarant: {
    data: [],
    totalCount: 0,
  },
  customsOffice: {
    data: [],
    totalCount: 0,
  },
  modeOfTransport: {
    data: [],
    totalCount: 0,
  },
  treatmentType: {
    data: [],
    totalCount: 0,
  },
  chemicalGoods: {
    data: [],
    totalCount: 0,
  },
  accuracies: {},
};

const rimmSlice = createSlice({
  name: 'rimm',
  initialState,
  reducers: {
    setEntityData: (
      state: RimmState,
      { payload }: PayloadAction<{ data: { resultList: IRimmDataItem[]; totalCount: number }; entity: RimmEntityType }>
    ) => {
      state[payload.entity].data = payload.data.resultList ?? [];
      state[payload.entity].totalCount = payload.data.totalCount ?? 0;
    },
    setSubEntityData: (
      state: RimmState,
      { payload }: PayloadAction<{ data: IRimmDataItem[]; entity: RimmSubEntityType; code: string }>
    ) => {
      state[payload.entity][payload.code] = {
        data: payload.data,
        totalCount: payload.data.length,
      };
    },
  },
});

export const { setEntityData, setSubEntityData } = rimmSlice.actions;
export default rimmSlice;
